<script>
import Detail from './Detail.svelte';

export let error;

const error_message = error ? error.toString() : '-';
const has_details = error && typeof error.fullDetails == 'function';
let show_full;
  
</script>

<Detail label="Error">
  {error_message}
  {#if has_details}
    <button on:click={() => show_full = true}>More</button>
  {/if}
</Detail>

{#if show_full}
  <section class="error-full">
    <button class="close" on:click={() => show_full = false}>&times;</button>
    {error.fullDetails()}
  </section>
{/if}

<style>
  .error-full {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 32px;

    background-color: #fff;
    color: #000;
    font-family: 'Courier New', Courier, monospace;
    overflow: auto;
    white-space: pre;
    z-index: 10000;
  }

  .close {
    position: fixed;
    top: 16px;
    right: 16px;
    width: 48px;
    height: 48px;
    background-color: #000;
    border-radius: 100px;
    color: #fff;
    font-size: 32px;
  }
</style>